import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { useNavigate } from "react-router-dom";
import { getBrandRole, postBrandUser, putBrandUser } from "../../../services/StoreUsers/PostStoreUsers";
import { getStoreLocalData } from "../../../utils/localStorage";

const UserCreateModal = ({
  userCreateModalVisible,
  setUserCreateModalVisible,
  sendDataToUserList,
  brandId,
  selectedUserItemValue,
  isWareHouseModel,
}) => {
  const navigate = useNavigate();
  const [emailValue, setEmailValue] = useState('');
  const [mobileNoValue, setMobileNoValue] = useState('');
  const [passwordValue, setPasswordValue] = useState('');
  const [firstNameValue, setFirstNameValue] = useState('');
  const [lastNameValue, setLastNameValue] = useState('');
  const [roleValue, setRoleValue] = useState('');

  const [emailError, setEmailError] = useState('');
  const [mobileNoError, setMobileNoError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [firstNameError, setFirstNameError] = useState('');
  // const [lastNameError, setLastNameError] = useState('');
  const [roleError, setRoleError] = useState('');

  const { storeLocalData } = getStoreLocalData();
    const countryCode = storeLocalData?.countryCode;

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState('');

  const [selectedTimeSlot, setSelectedTimeSlot] = useState([]);
  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);
  const [roleItems, setRoleItems] = useState([]);

  const fetchBrandRole = () => {
    getBrandRole(brandId)
      .then(response => {
        if (!response.data.error) {
          const role = isWareHouseModel
            ? response.data
            : response.data.filter(item => item.role !== 'ROLE_WAREHOUSE');
            const Res = role.map((item, index) => ({
              name: item.role.replace(/_/g, ' '),
              value: item.role,
            }));

          setRoleItems(Res);
        }
      })
      .catch(err => {
        console.error('Error:', err);
      });
  };

  useEffect(() => {
    fetchBrandRole();
  }, []);

  useEffect(() => {
    if (selectedUserItemValue !== null) {

      let savedMobileNo = selectedUserItemValue?.mobileNo;

      if (countryCode && selectedUserItemValue?.mobileNo?.startsWith(countryCode)) {
        savedMobileNo = selectedUserItemValue?.mobileNo?.replace(countryCode, "").trim();
      }

      setFirstNameValue(selectedUserItemValue?.firstName || '');
      setLastNameValue(selectedUserItemValue?.lastName.toString() || '');
      setEmailValue(selectedUserItemValue?.email || '');
      setMobileNoValue(savedMobileNo.toString() || '');
    }
  }, [selectedUserItemValue]);

  const handleMobileNumberChange = number => {
    // Perform input validation to allow only Indian mobile numbers
    // if (/^[56789]\d{0,9}$/.test(number) || number === '') {
    //   if (number.length === 10) {
    //     setMobileNoError(''); // Clear error if the input is valid
    //   } else {
    //     setMobileNoError('Please enter a 10-digit mobile number');
    //   }
    //   setMobileNoValue(number);
    // } else {
    //   setMobileNoError('Please enter a valid mobile number');
    // }


    let isValidPartial = false;
    let isValidFull = false;
    let requiredLength = 10;

    // Validation based on country code
    if (countryCode === "+91") {
      // India: starts with 5-9 and max 10 digits
      isValidPartial = /^[5-9]\d{0,9}$/.test(number) || number === "";
      isValidFull = /^[5-9]\d{9}$/.test(number);
      requiredLength = 10;

    } else if (countryCode === "+971") {
      // UAE: starts with 5 and max 9 digits
      isValidPartial = /^5\d{0,8}$/.test(number) || number === "";
      isValidFull = /^5\d{8}$/.test(number);
      requiredLength = 9;
    }

    if (isValidPartial) {
      if (number.length === requiredLength) {
        setMobileNoError("");
      } else {
        setMobileNoError(`Please enter a ${requiredLength}-digit mobile number`);
      }

      setMobileNoValue(number);
    } else {
      setMobileNoError("Please enter a valid mobile number");
    }
  };

  const handleRoleChange = selectedItem => {
    setRoleValue(selectedItem.role);
  };

  const [focusedField, setFocusedField] = useState('');

  const handleFocus = field => {
    setFocusedField(field);
  };

  const handleBlur = () => {
    setFocusedField('');
  };

  const handleConfirmPickup = () => {
    // Reset all previous errors
    setEmailError('');
    setMobileNoError('');
    setPasswordError('');
    setFirstNameError('');
    // setLastNameError('');
    setRoleError('');

    let isValid = true;
    if (!emailValue) {
      setEmailError('Email is required');
      isValid = false;
    }
    if (!mobileNoValue) {
      setMobileNoError('Mobile Number is required');
      isValid = false;
    }
    if (!firstNameValue) {
      setFirstNameError('First Name is required');
      isValid = false;
    }
    // if (!lastNameValue) {
    //   setLastNameError('Last Name is required');
    //   isValid = false;
    // }
    if (selectedUserItemValue === null && !passwordValue) {
      setPasswordError('Password is required');
      isValid = false;
    }
    if (selectedUserItemValue === null && !roleValue) {
      setRoleError('Role is required');
      isValid = false;
    }

    if (isValid) {
      if (!isSubmitButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsSubmitButtonPressed(true);

        if (selectedUserItemValue === null) {
          // Logic for creating a new pickup request
          const data = {
            brandId: brandId,
            email: emailValue,
            mobileNo: countryCode + mobileNoValue,
            password: passwordValue,
            firstName: firstNameValue,
            lastName: lastNameValue,
            role: roleValue,
          };

          // Call the service function for creating pickup request

          postBrandUser(brandId, data)
            .then(response => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const success = Res.success;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (success === true) {
                    setModalVisible(true);
                    setModalStatus('success');
                    setModalText(message);
                  } else {
                    setModalVisible(true);
                    setModalStatus('not Success');
                    setModalText(message);
                  }

                  setEmailValue('');
                  setMobileNoValue('');
                  setPasswordValue('');
                  setFirstNameValue('');
                  setLastNameValue('');
                  setRoleValue('');

                  setEmailError('');
                  setMobileNoError('');
                  setPasswordError('');
                  setFirstNameError('');
                  // setLastNameError('');
                  setRoleError('');
                  setIsSubmitButtonPressed(false);
                  sendDataToUserList({
                    success: true,
                  });
                  setUserCreateModalVisible(false);
                }
              }
            })
            .catch(err => {
              console.error('Error:', err);
            });
        } else {
          const data = {
            ...selectedUserItemValue,
            brandId: brandId,
            email: emailValue,
            mobileNo: countryCode + mobileNoValue,
            password: passwordValue,
            firstName: firstNameValue,
            lastName: lastNameValue,
          };
          // Call the service function for creating pickup request

          putBrandUser(brandId, data)
            .then(response => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const success = Res.success;
                  // sendResponse({message, status, modalFun: false});
                  // Reset state variables
                  if (success === true) {
                    setModalVisible(true);
                    setModalStatus('success');
                    setModalText(message);
                  } else {
                    setModalVisible(true);
                    setModalStatus('not Success');
                    setModalText(message);
                  }

                  setEmailValue('');
                  setMobileNoValue('');
                  setPasswordValue('');
                  setFirstNameValue('');
                  setLastNameValue('');
                  setRoleValue('');

                  setEmailError('');
                  setMobileNoError('');
                  setPasswordError('');
                  setFirstNameError('');
                  // setLastNameError('');
                  setRoleError('');
                  setIsSubmitButtonPressed(false);
                  sendDataToUserList({
                    success: true,
                  });
                  setUserCreateModalVisible(false);
                }
              }
            })
            .catch(err => {
              console.error('Error:', err);
            });
        }
      }
    } else {
      setIsSubmitButtonPressed(false);
    }
  };

  const handleModalClose = () => {
    setSelectedTimeSlot([]);
    setEmailValue('');
    setMobileNoValue('');
    setPasswordValue('');
    setFirstNameValue('');
    setLastNameValue('');
    setRoleValue('');

    setEmailError('');
    setMobileNoError('');
    setPasswordError('');
    setFirstNameError('');
    // setLastNameError('');
    setRoleError('');
    setIsSubmitButtonPressed(false);
    sendDataToUserList({
      success: true,
    });
    setUserCreateModalVisible(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
         
        visible={userCreateModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!userCreateModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-2 "
            style={{  
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <div>
                <img
                  src={"Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Quick_add_customer.png"}
                />
              </div>
              <p className=" text-4xl text-primary-50 font-semibold uppercase">
                User Detail
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 "
              ></Button>
            </div>
                      
              
              <div className="mx-4">
                <InputText
                  value={firstNameValue}
                  onChange={(e) => setFirstNameValue(e.target.value)}
                  className="w-full text-xl p-2 border-round-xl shadow-2"
                  style={{
                    backgroundColor: "#fff",
                  }}
                  placeholder="First Name"
                />
                {firstNameError && <p className="text-lg font-normal" style={{color:"red"}}>{firstNameError}</p>}
              </div>
              <div className="mx-4">
                <InputText
                  value={lastNameValue}
                  onChange={(e) => setLastNameValue(e.target.value)}
                  className="w-full text-xl p-2 border-round-xl shadow-2"
                  style={{
                    backgroundColor: "#fff",
                  }}
                  placeholder="Last Name"
                />
              </div>
              <div className="mx-4">
                <InputText
                  value={mobileNoValue}
                  onChange={(e) => handleMobileNumberChange(e.target.value)}
                  className="w-full text-xl p-2 border-round-xl shadow-2"
                  style={{
                    backgroundColor: "#fff",
                  }}
                  keyboardType='numeric'
                  placeholder="Mobile NUmber"
                />
                {mobileNoError && <p className="text-lg font-normal" style={{color:"red"}}>{mobileNoError}</p>}
              </div>
              <div className="mx-4">
                <InputText
                  value={emailValue}
                  onChange={(e) => setEmailValue(e.target.value)}
                  className="w-full text-xl p-2 border-round-xl shadow-2"
                  style={{
                    backgroundColor: "#fff",
                  }}
                  placeholder="Email"
                />
                {emailError && <p className="text-lg font-normal" style={{color:"red"}}>{emailError}</p>}
              </div>
              <div className="mx-4">
                <InputText
                  value={passwordValue}
                  onChange={(e) => setPasswordValue(e.target.value)}
                  className="w-full text-xl p-2 border-round-xl shadow-2"
                  style={{
                    backgroundColor: "#fff",
                  }}
                  placeholder="Password"
                />
                {passwordError && <p className="text-lg font-normal" style={{color:"red"}}>{passwordError}</p>}
              </div>
               {selectedUserItemValue === null && <div className="mx-4">
                <div className="flex flex-1 ">
                  <Dropdown
                    value={roleValue}
                    onChange={(e) => setRoleValue(e.value)}
                    options={roleItems}
                    optionLabel="name"
                    placeholder="User Role"
                    className="w-full border-round-xl  text-2xl text-xl shadow-2"
                  />
                </div>
                {roleError && <p className="text-lg font-normal" style={{color:"red"}}>{roleError}</p>}
              </div>}
               
                <Button
                  className="mt-1 mb-3 mx-4 border-round-xl "
                  onClick={handleConfirmPickup}
                  disabled={isSubmitButtonPressed}
                >
                  <p className=" w-full text-2xl font-semibold flex justify-content-center">
                  Add User
                  </p>
                </Button>
              
            </div>
           
        )}
      ></Dialog>
    </div>
  );
};

export default UserCreateModal;
